export default __webpack_public_path__ + "static/media/affisch_2_a3_home_printer.16123fc8.png";